import React, { ReactNode, useEffect, useState } from "react";
import { getNotifications, markNotificationAsRead, markAllNotificationsAsRead, Notification } from "../../api/notifications";
import { getDefaultConfig } from "../../api/api";
import SettingsModal from "../SettingsModal/SettingsModal";
import {
	AppBar,
	Drawer,
	Toolbar,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	IconButton,
	Typography,
	Box,
	Menu,
	Tooltip,
	MenuItem,
	Avatar,
	Badge,
	Divider,
	ListItemButton,
	Collapse,
} from "@mui/material";
import NotificationIcon from "../../assets/images/NotificationIcon";
import { useTheme } from "@mui/material/styles";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/authSlice";
import { setConfigAndFlags, selectUIConfig, selectFeatureFlags } from "../../store/uiConfigSlice";
import LeftArrowIcon from "../../assets/images/LeftArrow";
import RightArrowIcon from "../../assets/images/RightArrow";
import HomeIcon from "../../assets/images/HomeIcon";
import StorageIcon from "../../assets/images/StorageIcon";
import SettingIcon from "../../assets/images/SettingIcon";
import HandshakeIcon from '@mui/icons-material/Handshake';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ConfigureIcon from "../../assets/images/ConfigureIcon";
import PersonIcon from '@mui/icons-material/Person';
import AttributesIcon from "../../assets/images/AttributesIcon";
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import VectorIcon from "../../assets/images/VectorIcon";
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ChevronIcon from "../../assets/images/ChevronIcon";
import DescriptionIcon from '@mui/icons-material/Description';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BusinessIcon from '@mui/icons-material/Business';
import { RootState } from "../../store/appStore";
import frontendSettings from "../../../frontend_settings.json";
import { privacyPolicySections } from "../../constants/common";
import Dialog from "../Dialog/Dialog";

import {
	selectProgressStatus,
	setProgressStatus,
} from "../../store/progressStatus";
import PowerBI from "../../assets/images/PowerBI";
import { UIConfig } from "../../api";
const DefaultLayout: React.FC = () => {
	const progress = useSelector(selectProgressStatus);
	const theme = useTheme();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const currentPath = location.pathname;
	const userInfo:any = useSelector((state: RootState) => state.auth.user);
	const isAdmin = userInfo?.roles?.includes("Admin");
	const drawerWidth = 250;
	const miniDrawerWidth = 60;
	const date = new Date();
	const currentYear = date.getFullYear();

	const [sideBarItems, setSideBarItems] = useState([
		{
			name: "Home",
			icon: <HomeIcon />,
			path: "/homepage",
			isActive: false,
			disabled: false,
			configKey: null
		},
		{
			name: "Document Management",
			icon: <DescriptionIcon />,
			path: "/homepage/management",
			isActive: false,
			disabled: false,
			configKey: null
		},
		{
			name: "RFP Review",
			icon: <AssignmentTurnedInIcon />,
			path: "/homepage/contract-review",
			isActive: false,
			disabled: false,
			configKey: "rfpReview"
		},
		{
			name: "Contract Insights",
			icon: <VectorIcon />,
			path: "/homepage/intelligence",
			isActive: false,
			disabled: false,
			configKey: "contractInsights"
		},
		{
			name: "Contract Attributes",
			icon: <AttributesIcon />,
			path: "/homepage/attributes",
			isActive: false,
			disabled: false,
			configKey: "contractAttributes"
		},
		{
			name: "Negotiations",
			icon: <HandshakeIcon />,
			path: "/homepage/negotiations",
			isActive: false,
			disabled: false,
			configKey: "negotiations"
		},
		...(isAdmin
			? [
				{
					name: "Opportunities",
					icon: <FindInPageIcon />,
					path: "/homepage/opportunities",
					isActive: false,
					disabled: false,
					configKey: "opportunities"
				}
			]
			: [])
	]);

	const [adminItems, setAdminItems] = useState([
		{
			name: "Scenario Management",
			icon: <AccountTreeIcon />,
			path: "/homepage/scenarios",
			isActive: false,
			disabled: false,
		},
		{
			name: "User Management",
			icon: <PersonIcon />,
			path: "/homepage/user",
			isActive: false,
			disabled: false,
		},
		{
			name: "Project Management",
			icon: <BusinessIcon />,
			path: "/homepage/project",
			isActive: false,
			disabled: false,
		}
	]);

	React.useEffect(() => {
		setSideBarItems(
			sideBarItems.map((ele) => ({
				...ele,
				isActive: ele.path === location.pathname,
			}))
		);

		setAdminItems(
			adminItems.map((ele) => ({
				...ele,
				isActive: ele.path === location.pathname,
			}))
		);
	}, [location.pathname]);

	const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
		null
	);

	const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorElUser(event.currentTarget);
	};

	const handleCloseUserMenu = () => {
		setAnchorElUser(null);
	};
	const handleLogout = (event: React.MouseEvent<HTMLElement>) => {
		dispatch(logout());
		handleCloseUserMenu();
	};

	const handleOpenSettings = () => {
		setSettingsModalOpen(true);
		handleCloseUserMenu();
	};

	const [open, setOpen] = React.useState<boolean>(false);
	const [adminExpanded, setAdminExpanded] = React.useState<boolean>(false);

	const handleDrawerOpen = () => {
		setOpen(!open);
	};

	const handleToggleAdmin = () => {
		// If sidebar is closed, open it first
		if (!open) {
			setOpen(true);
		}
		// Toggle admin section
		setAdminExpanded(!adminExpanded);
	};

	const handleSelect = (event: React.MouseEvent<HTMLElement>) => {
		const data = event.currentTarget.getAttribute("data-value");
		let link: string = "";
		let found = false;

		// Check in main sidebar items
		setSideBarItems(
			sideBarItems.map((ele) => {
				if (ele.name === data) {
					ele.isActive = true;
					link = ele.path;
					found = true;
				} else ele.isActive = false;
				return ele;
			})
		);

		// Check in admin items if not found in main items
		if (!found) {
			setAdminItems(
				adminItems.map((ele) => {
					if (ele.name === data) {
						ele.isActive = true;
						link = ele.path;
						found = true;
					} else ele.isActive = false;
					return ele;
				})
			);
		}

		if (link) {
			navigate(link);
		}
	};

	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogTitle, setDialogTitle] = useState("");
	const [notifications, setNotifications] = useState<Notification[]>([]);
	const [notificationCount, setNotificationCount] = useState(0);
	const [notificationMenuAnchor, setNotificationMenuAnchor] = useState<null | HTMLElement>(null);
	const [settingsModalOpen, setSettingsModalOpen] = useState(false);
	// Using UI config from Redux store instead of local state
	const uiConfig = useSelector(selectUIConfig);
	const featureFlags = useSelector(selectFeatureFlags);

	const fetchNotifications = async () => {
		try {
			const notificationData = await getNotifications();
			setNotifications(notificationData);
			// Count only unread (NEW) notifications
			const unreadCount = notificationData.filter(notification => notification.status === "New").length;
			setNotificationCount(unreadCount);
		} catch (error) {
			console.error('Error fetching notifications:', error);
		}
	};

	const handleNotificationClick = (event: React.MouseEvent<HTMLElement>) => {
		setNotificationMenuAnchor(event.currentTarget);
	};

	const handleNotificationClose = () => {
		setNotificationMenuAnchor(null);
	};

	const handleMarkAsRead = async (notificationId: number) => {
		try {
			await markNotificationAsRead(notificationId);
			// Update local state
			setNotifications(prevNotifications =>
				prevNotifications.map(notification =>
					notification.notification_id === notificationId
						? { ...notification, status: "Read" }
						: notification
				)
			);
			// Update count
			setNotificationCount(prev => Math.max(0, prev - 1));
		} catch (error) {
			console.error('Error marking notification as read:', error);
		}
	};

	const handleMarkAllAsRead = async () => {
		try {
			await markAllNotificationsAsRead();
			// Update local state
			setNotifications(prevNotifications =>
				prevNotifications.map(notification => ({ ...notification, status: "Read" }))
			);
			// Update count
			setNotificationCount(0);
			// Close menu
			handleNotificationClose();
		} catch (error) {
			console.error('Error marking all notifications as read:', error);
		}
	};

	// Function to fetch UI configuration and cache to Redux store
	const fetchUIConfig = async () => {
		try {
			const config = await getDefaultConfig();

			// Save config to Redux store for global access
			dispatch(setConfigAndFlags({
				uiConfig: config.uiConfig,
				featureFlags: config.featureFlags
			}));

			// Update sidebar items based on configuration
			setSideBarItems(prevItems => {
				return prevItems.map(item => {
					// Skip items without configKey (always enabled)
					if (!item.configKey) return item;

					// Check if feature is disabled in config
					const isDisabled = config.featureFlags.features &&
						(item.configKey in config.featureFlags.features) &&
						config.featureFlags.features[item.configKey] === false;

					return {
						...item,
						disabled: isDisabled
					};
				});
			});
		} catch (error) {
			console.error('Error fetching UI configuration:', error);
		}
	};

	useEffect(() => {
		// Initial fetch of notifications and UI config (if not already cached)
		fetchNotifications();

		// Only fetch UI config if it's not already in Redux store
		if (!uiConfig || !featureFlags) {
			fetchUIConfig();
		} else {
			// If config already exists in Redux, just update sidebar items
			setSideBarItems(prevItems => {
				return prevItems.map(item => {
					// Skip items without configKey (always enabled)
					if (!item.configKey) return item;

					// Check if feature is disabled in config
					const isDisabled = featureFlags.features &&
						(item.configKey in featureFlags.features) &&
						featureFlags.features[item.configKey] === false;

					return {
						...item,
						disabled: isDisabled
					};
				});
			});
		}

		// Refresh notifications every 5 minutes
		const interval = setInterval(fetchNotifications, 5 * 60 * 1000);

		return () => {
			clearInterval(interval);
		};
	}, [uiConfig, featureFlags]);

	const handleOpenDialog = (data: string) => {
		setDialogTitle(data);
		setDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setDialogOpen(false);
		setDialogTitle("");
	};

	return (
		<div>
			{/* Main App Bar */}
			<AppBar
				position="fixed"
				sx={{ background: theme.palette.background.default }}
			>
				<Box paddingX={2}>
					<Toolbar disableGutters>
						<Box
							component="img"
							sx={{ width: "135px" }}
							src={
								uiConfig?.login?.photo
							}
						></Box>

						<Box
							sx={{
								flexGrow: 1,
								display: "flex",
							}}
						>
							<Divider
								sx={{ borderColor: "#9E9E9E", mx: 2 }}
								orientation="vertical"
								flexItem
							/>
							<Typography
								variant="h6"
								align="center"
								sx={{
									fontWeight: 400,
									color: theme.palette.text.primary,
								}}
							>
								{uiConfig?.title ? uiConfig.title : "ContractIQ"}
							</Typography>
						</Box>

						<Box
							sx={{
								mx: 1,
								cursor: "not-allowed",
								opacity: 0.4,
							}}
						></Box>

						<Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center', gap: 2 }}>
							<Tooltip title="Notifications">
								<IconButton onClick={handleNotificationClick}>
									<Badge badgeContent={notificationCount} color="primary">
										<NotificationIcon />
									</Badge>
								</IconButton>
							</Tooltip>
							<Menu
								anchorEl={notificationMenuAnchor}
								id="notification-menu"
								open={Boolean(notificationMenuAnchor)}
								onClose={handleNotificationClose}
								PaperProps={{
									style: {
										maxHeight: 400,
										width: '350px',
										overflow: 'auto',
									},
								}}
								transformOrigin={{ horizontal: 'right', vertical: 'top' }}
								anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
							>
								<Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
									<Typography variant="h6">Notifications</Typography>
									{notificationCount > 0 && (
										<Typography
											variant="body2"
											color="primary"
											component="button"
											onClick={handleMarkAllAsRead}
											sx={{ cursor: 'pointer', border: 'none', background: 'none' }}
										>
											Mark all as read
										</Typography>
									)}
								</Box>
								<Divider />
								{notifications.length === 0 ? (
									<Box sx={{ p: 2, textAlign: 'center' }}>
										<Typography variant="body2" color="text.secondary">
											No notifications
										</Typography>
									</Box>
								) : (
									notifications.map((notification) => (
										<MenuItem
											key={notification.notification_id}
											onClick={() => handleMarkAsRead(notification.notification_id)}
											component="div"
											sx={{
												py: 1.5,
												px: 2,
												borderLeft: notification.status === 'New' ?
													`4px solid ${theme.palette.primary.main}` : 'none',
												background: notification.status === 'New' ?
													'rgba(0, 0, 0, 0.04)' : 'inherit',
												whiteSpace: 'normal',
											}}
										>
											<Box sx={{ width: '100%' }}>
												<Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
													<Typography
														variant="body2"
														component="span"
														color="text.primary"
														sx={{
															fontWeight: notification.status === 'New' ? 700 : 400,
															paddingRight: 1
														}}
													>
														<Box
															component="span"
															sx={{
																display: 'inline-block',
																width: 10,
																height: 10,
																borderRadius: '50%',
																marginRight: 1,
																background: notification.severity === 'Info' ?
																	theme.palette.primary.main :
																	notification.severity === 'Warning' ?
																		'orange' :
																		notification.severity === 'Error' ?
																			'red' :
																			'green'
															}}
														/>
														{notification.severity}
													</Typography>
													<Typography variant="caption" color="text.secondary">
														{(() => {
															// Convert database UTC time to local time
															const utcTimeStr = notification.created_at.replace(' ', 'T') + 'Z';
															const utcDate = new Date(utcTimeStr);

															// Use toLocaleString() for proper formatting
															return utcDate.toLocaleString();
														})()}
													</Typography>
												</Box>
												<Typography variant="body2" color="text.primary">
													{notification.message}
												</Typography>
												{notification.contract_id && (
													<Typography variant="caption" color="text.secondary">
														Contract ID: {notification.contract_id}
													</Typography>
												)}
											</Box>
										</MenuItem>
									))
								)}
							</Menu>
							<Tooltip title="Open settings">
								<IconButton
									onClick={handleOpenUserMenu}
									sx={{
										py: 1,
									}}
								>
									<Avatar
										alt={`Shubham Mishra`}
										sx={{
											fontSize: "14px",
											background:
												theme.palette.background
													.default,
											border: `2px solid ${theme.palette.primary.main}`,
											color: theme.palette.text.primary,
										}}
									>
										{userInfo?.initiatls}
									</Avatar>
									<Box
										component="div"
										sx={{
											mx: 2,
											color: theme.palette.primary.main,
										}}
									>
										<ChevronIcon />
									</Box>
								</IconButton>
							</Tooltip>
							<Menu
								sx={{ mt: "45px" }}
								id="menu-appbar"
								anchorEl={anchorElUser}
								anchorOrigin={{
									vertical: "top",
									horizontal: "right",
								}}
								keepMounted
								transformOrigin={{
									vertical: "top",
									horizontal: "right",
								}}
								open={Boolean(anchorElUser)}
								onClose={handleCloseUserMenu}
							>
								<MenuItem onClick={handleOpenSettings}>
									<Typography sx={{ textAlign: "center" }}>
										Settings
									</Typography>
								</MenuItem>
								<MenuItem onClick={handleLogout}>
									<Typography sx={{ textAlign: "center" }}>
										Logout
									</Typography>
								</MenuItem>
							</Menu>
						</Box>
					</Toolbar>
				</Box>
			</AppBar>

			{/* Side Bar */}
			{
				<Drawer
					sx={{
						"& .MuiDrawer-paper": {
							marginTop: 9,
							width: open ? drawerWidth : miniDrawerWidth,
							transition: "width 0.3s ease",
							boxSizing: "border-box",
							borderRadius: `0 30px 30px 0`,
							maxHeight: 800,
						},
					}}
					variant="permanent"
					anchor="left"
					open={open}
				>
					{open ? (
						<Box
							component="div"
							sx={{
								width: "32px",
								position: "absolute",
								right: 0,
								zIndex: 99,
								marginTop: 3,
								cursor: "pointer",
								color: theme.palette.primary.main,
							}}
							onClick={handleDrawerOpen}
						>
							<LeftArrowIcon />
						</Box>
					) : (
						<Box
							component="div"
							sx={{
								width: "32px",
								position: "absolute",
								right: 0,
								zIndex: 99,
								marginTop: 3,
								cursor: "pointer",
								color: theme.palette.primary.main,
							}}
							onClick={handleDrawerOpen}
						>
							<RightArrowIcon />
						</Box>
					)}
					<List
						sx={{
							marginTop: 8,
							position: "relative",
							height: "75vh",
							display: "flex",
							flexDirection: "column"
						}}
					>
						{/* Main sidebar items */}
						<Box sx={{ flexGrow: 1 }}>
							{sideBarItems.map((text, index) => (
								<ListItem
									key={text.name}
									disablePadding
									sx={{
										display: text.disabled ? "none" : "block",
										py: 1,
									}}
								>
									<ListItemButton
										data-value={text.name}
										sx={[
											{
												minHeight: 48,
												justifyContent: "center",
												background: text.isActive
													? theme.palette.primary.main
													: theme.palette.secondary
														.contrastText,
												'&:hover': {
													background: text.isActive
														? theme.palette.primary.dark
														: '',
												},
												pointerEvents: text.disabled
													? "none"
													: "auto",
												cursor: text.disabled
													? "copy"
													: "pointer",
												opacity: text.disabled ? 0.5 : 1,
												px: open ? 2 : 0, // Adjust padding based on drawer state
											},
											open
												? {
													justifyContent: "initial",
												}
												: {
													justifyContent: "center",
												},
										]}
										onClick={handleSelect}
									>
										<ListItemIcon
											data-value={text.name}
											sx={[
												{
													minWidth: 40, // Ensure consistent minimum width
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													mr: open ? 1 : 0, // Margin only when drawer is open
												},
											]}
										>
											<Box
												component="div"
												sx={{
													color: text.isActive
														? theme.palette.secondary
															.contrastText
														: theme.palette.text
															.primary,
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													width: '32px',
													height: '32px',
													overflow: 'visible',
													position:
														index ===
															sideBarItems.length - 1
															? "absolute"
															: "relative",
													bottom:
														index ===
															sideBarItems.length - 1
															? 0
															: "auto",
												}}
											>
												{React.cloneElement(text.icon, {
													width: 32,
													height: 32
												})}
											</Box>
										</ListItemIcon>
										{open && (
											<ListItemText
												data-value={text.name}
												primary={text.name}
												sx={{
													opacity: 1,
													color: text.isActive
														? theme.palette.secondary.contrastText
														: "",
												}}
											/>
										)}
									</ListItemButton>
								</ListItem>
							))}
						</Box>

						{/* Admin section - only visible for admin users */}
						{isAdmin && (
							<Box sx={{ mt: 'auto' }}>
								<Divider sx={{ my: 2 }} />

								{/* Admin header with toggle */}
								<ListItem disablePadding>
									<ListItemButton
										onClick={handleToggleAdmin}
										sx={{
											minHeight: 48,
											justifyContent: open ? "initial" : "center",
											px: open ? 2 : 0,
										}}
									>
										<ListItemIcon
											sx={{
												minWidth: 40,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												mr: open ? 1 : 0,
											}}
										>
											<Box
												component="div"
												sx={{
													color: theme.palette.text.primary,
													display: 'flex',
													alignItems: 'center',
													justifyContent: 'center',
													width: '32px',
													height: '32px',
												}}
											>
												<AdminPanelSettingsIcon />
											</Box>
										</ListItemIcon>
										{open && (
											<>
												<ListItemText primary="Admin" />
												{adminExpanded ? <ExpandLess /> : <ExpandMore />}
											</>
										)}
									</ListItemButton>
								</ListItem>

								{/* Collapsible admin items */}
								<Collapse in={adminExpanded && open} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										{adminItems.map((item) => (
											<ListItem key={item.name} disablePadding>
												<ListItemButton
													data-value={item.name}
													onClick={handleSelect}
													sx={{
														minHeight: 48,
														justifyContent: open ? "initial" : "center",
														pl: open ? 4 : 0,
														background: item.isActive
															? theme.palette.primary.main
															: theme.palette.secondary.contrastText,
														'&:hover': {
															background: item.isActive
																? theme.palette.primary.dark
																: '',
														},
														color: item.isActive
															? theme.palette.secondary.contrastText
															: theme.palette.text.primary,
													}}
												>
													<ListItemIcon
														data-value={item.name}
														sx={{
															minWidth: 40,
															display: 'flex',
															alignItems: 'center',
															justifyContent: 'center',
															mr: open ? 1 : 0,
															color: item.isActive
																? theme.palette.secondary.contrastText
																: theme.palette.text.primary,
														}}
													>
														{React.cloneElement(item.icon, { width: 24, height: 24 })}
													</ListItemIcon>
													{open && (
														<ListItemText
															data-value={item.name}
															primary={item.name}
															sx={{
																opacity: 1,
																color: item.isActive
																	? theme.palette.secondary.contrastText
																	: "",
															}}
														/>
													)}
												</ListItemButton>
											</ListItem>
										))}
									</List>
								</Collapse>
							</Box>
						)}
					</List>
				</Drawer>
			}

			<main
				style={{
					flexGrow: 1,
					marginLeft: open
						? `calc(${drawerWidth}px)`
						: `calc(${miniDrawerWidth}px)`,
					padding: "15px 15px 0 15px",
					minHeight: "100vh",
					background: "#F9F9F9",
				}}
			>
				<Outlet />
			</main>

			{/* footer */}
			<Box
				component="footer"
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					gap: 2,
					py: 1,
					backgroundColor: theme.palette.primary.main,
					color: "#fff",
					position: "fixed",
					bottom: 0,
					left: open ? `${drawerWidth}px` : `${miniDrawerWidth}px`,
					right: 0,
					zIndex: theme.zIndex.drawer + 1,
					cursor: "pointer",
				}}
			>
				<Typography
					variant="body2"
					sx={{
						"&:hover": {
							textDecoration: "underline",
						},
					}}
				>
					{currentYear}
				</Typography>
				<Typography
					variant="body2"
					onClick={() => handleOpenDialog("Terms and Conditions")}
					sx={{
						"&:hover": {
							textDecoration: "underline",
						},
					}}
				>
					Terms and Conditions
				</Typography>
			</Box>
			{/* Dialog */}
			<Dialog
				open={dialogOpen}
				onClose={handleCloseDialog}
				title={dialogTitle}
				sections={privacyPolicySections.data}
			/>

			{/* Settings Modal */}
			<SettingsModal
				open={settingsModalOpen}
				onClose={() => setSettingsModalOpen(false)}
			/>
		</div>
	);
};

export default DefaultLayout;
